import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/global-board/icons/edit.svg'


const _withScopeId = n => (_pushScopeId("data-v-4b5607a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col w-full items-center h-full min-h-screen" }
const _hoisted_2 = { class: "bg-white rounded-lg mb-12 w-full p-12" }
const _hoisted_3 = { class: "flex flex-row justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold" }, "General Information", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: _imports_0,
  width: "16"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary" }, "Edit", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 py-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Personal Information")
], -1))
const _hoisted_9 = { class: "flex flex-col mt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Name", -1))
const _hoisted_11 = { class: "font-thin my-5 ml-2" }
const _hoisted_12 = { class: "flex flex-row mt-4 justify-between items-start" }
const _hoisted_13 = { class: "flex flex-col w-full" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Email", -1))
const _hoisted_15 = { class: "font-thin my-5 ml-2" }
const _hoisted_16 = { class: "flex flex-col w-full" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Phone", -1))
const _hoisted_18 = { class: "font-thin my-5 ml-2" }
const _hoisted_19 = { class: "flex flex-col mt-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Address", -1))
const _hoisted_21 = { class: "font-thin my-5 ml-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 py-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Profile")
], -1))
const _hoisted_23 = { class: "space-y-7" }
const _hoisted_24 = { class: "flex flex-col mt-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm" }, "Summary", -1))
const _hoisted_26 = {
  key: 0,
  class: "text-sm text-justify mt-4 ml-2"
}
const _hoisted_27 = {
  key: 1,
  class: "ml-6"
}
const _hoisted_28 = { class: "flex flex-col mt-4" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm mb-2" }, "Work experience", -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "flex flex-row" }
const _hoisted_33 = { class: "capitalize" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "-", -1))
const _hoisted_35 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "flex flex-row" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = { class: "flex flex-col mt-4" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm mb-2" }, "Education", -1))
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_43 = { class: "flex flex-row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "-", -1))
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "flex flex-row" }
const _hoisted_48 = { class: "flex flex-col mt-4" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm mb-2" }, "Resume", -1))
const _hoisted_50 = {
  key: 0,
  class: "w-full flex flex-row items-center py-2 px-3 border border-gray-100 shadow rounded-lg"
}
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<span class=\"\" data-v-4b5607a0><svg class=\"h-8 w-8 text-primary\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-4b5607a0><path stroke=\"none\" d=\"M0 0h24v24H0z\" data-v-4b5607a0></path><path d=\"M9 5H7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2V7a2 2 0 0 0 -2 -2h-2\" data-v-4b5607a0></path><rect x=\"9\" y=\"3\" width=\"6\" height=\"4\" rx=\"2\" data-v-4b5607a0></rect><path d=\"M9 14l2 2l4 -4\" data-v-4b5607a0></path></svg></span>", 1)
const _hoisted_52 = { class: "flex flex-col ml-2" }
const _hoisted_53 = { class: "text-xs text-gray-400 uppercase" }
const _hoisted_54 = { class: "flex flex-col mt-4" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm mb-2" }, "Other document", -1))
const _hoisted_56 = {
  key: 0,
  class: "w-full flex flex-row items-center py-2 px-3 border border-gray-100 shadow rounded-lg"
}
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<span class=\"\" data-v-4b5607a0><svg class=\"h-8 w-8 text-primary\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-4b5607a0><path stroke=\"none\" d=\"M0 0h24v24H0z\" data-v-4b5607a0></path><path d=\"M9 5H7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2V7a2 2 0 0 0 -2 -2h-2\" data-v-4b5607a0></path><rect x=\"9\" y=\"3\" width=\"6\" height=\"4\" rx=\"2\" data-v-4b5607a0></rect><path d=\"M9 14l2 2l4 -4\" data-v-4b5607a0></path></svg></span>", 1)
const _hoisted_58 = { class: "flex flex-col ml-2" }
const _hoisted_59 = { class: "flex flex-col ml-2" }
const _hoisted_60 = { class: "text-xs text-gray-400 uppercase" }
const _hoisted_61 = {
  key: 1,
  class: "ml-6"
}
const _hoisted_62 = { class: "flex flex-col mt-4" }
const _hoisted_63 = { class: "font-semibold text-sm mb-2" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Links ")
const _hoisted_65 = { class: "relative top-1" }
const _hoisted_66 = {
  key: 0,
  class: ""
}
const _hoisted_67 = ["href"]
const _hoisted_68 = {
  key: 1,
  class: "ml-6"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 mt-8" }, null, -1))
const _hoisted_70 = { class: "mt-8" }
const _hoisted_71 = { class: "flex flex-row justify-between items-center" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold" }, "Skills", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: _imports_0,
  width: "16"
}, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary" }, "Edit", -1))
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]
const _hoisted_76 = {
  key: 0,
  class: "flex flex-row flex-wrap mt-6"
}
const _hoisted_77 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-6" }, "N/A", -1))
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 mt-4" }, null, -1))
const _hoisted_81 = { class: "mt-8" }
const _hoisted_82 = { class: "flex flex-row justify-between items-center" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold" }, "Preferences", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: _imports_0,
  width: "16"
}, null, -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary" }, "Edit", -1))
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = { class: "" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 py-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Expected salary")
], -1))
const _hoisted_89 = { class: "flex flex-row" }
const _hoisted_90 = { class: "mt-4 flex flex-col w-1/6" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Currency", -1))
const _hoisted_92 = { class: "mt-2 ml-6" }
const _hoisted_93 = { class: "mt-4 flex flex-col" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Salary per year", -1))
const _hoisted_95 = {
  key: 0,
  class: "mt-2 ml-6"
}
const _hoisted_96 = {
  key: 1,
  class: "mt-2 ml-6"
}
const _hoisted_97 = { class: "" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 py-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Preferred work type")
], -1))
const _hoisted_99 = { class: "mt-4" }
const _hoisted_100 = {
  key: 0,
  class: "list-none"
}
const _hoisted_101 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            class: "flex flex-row items-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.edit(1)))
          }, _hoisted_7)
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.form.first_name) + " " + _toDisplayString(_ctx.form.last_name), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.form.email), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.form.phone), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.candidate_location), 1)
        ]),
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            (_ctx.form.summary)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.form.summary), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_27, "N/A"))
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.candidate_work_histories, (work, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "flex flex-col ml-6 mb-3"
              }, [
                (_ctx.form.candidate_work_histories[0].job_title === '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, " N/A "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(new Date(work.start_date).toLocaleString("default", {
                        month: "short",
                      })) + " " + _toDisplayString(new Date(work.start_date).getFullYear()), 1),
                        _hoisted_34,
                        (!work.is_current)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(new Date(work.end_date).toLocaleString("default", {
                        month: "short",
                      })) + " " + _toDisplayString(new Date(work.end_date).getFullYear()), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36, "Current"))
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(work.job_title) + " at " + _toDisplayString(work.company_name) + " ", 1),
                          _createElementVNode("span", _hoisted_38, "(" + _toDisplayString(_ctx.getIndustryName(work.industry)) + ")", 1)
                        ])
                      ])
                    ]))
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.candidate_education_histories, (education, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "ml-6"
              }, [
                (_ctx.form.candidate_education_histories[0].degree === '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, " N/A "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("span", null, _toDisplayString(new Date(education.start_date).toLocaleString("default", {
                        month: "short",
                      })) + " " + _toDisplayString(new Date(education.start_date).getFullYear()), 1),
                        _hoisted_44,
                        (!education.is_current)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(new Date(education.end_date).toLocaleString("default", {
                        month: "short",
                      })) + " " + _toDisplayString(new Date(education.end_date).getFullYear()), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_46, "Current"))
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", null, _toDisplayString(education.degree) + " at " + _toDisplayString(education.learning_center), 1)
                      ])
                    ]))
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            (_ctx.fileResume !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getFileName(_ctx.fileResume)), 1),
                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.getFileExtension(_ctx.fileResume)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            (_ctx.fileOther && _ctx.fileOther !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getFileName(_ctx.fileOther)), 1),
                      _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.getFileExtension(_ctx.fileOther)), 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_61, "N/A"))
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("span", _hoisted_63, [
              _hoisted_64,
              _createElementVNode("span", _hoisted_65, [
                _createVNode(_component_Tooltip, { message: "You can include your blog, portfolio, Github, social media profiles and any other links that show information relevant to your application." })
              ])
            ]),
            (_ctx.form?.link)
              ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                  _createElementVNode("a", {
                    href: _ctx.form.link,
                    target: "_blank"
                  }, null, 8, _hoisted_67),
                  _createTextVNode(_toDisplayString(_ctx.form.link), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_68, "N/A"))
          ])
        ])
      ]),
      _hoisted_69,
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _hoisted_72,
          _createElementVNode("button", {
            class: "flex flex-row items-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.edit(2)))
          }, _hoisted_75)
        ]),
        (_ctx.skills.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "bg-primary-light rounded-lg px-3 py-1 text-primary m-1"
                }, _toDisplayString(skill), 1))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_79))
      ]),
      _hoisted_80,
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          _hoisted_83,
          _createElementVNode("button", {
            class: "flex flex-row items-center",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit(3)))
          }, _hoisted_86)
        ]),
        _createElementVNode("div", _hoisted_87, [
          _hoisted_88,
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _hoisted_91,
              _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.form.salary_currency ? _ctx.form.salary_currency : "N/A"), 1)
            ]),
            _createElementVNode("div", _hoisted_93, [
              _hoisted_94,
              (_ctx.form.current_salary)
                ? (_openBlock(), _createElementBlock("span", _hoisted_95, "$ " + _toDisplayString(_ctx.form.current_salary), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_96, "N/A"))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_97, [
          _hoisted_98,
          _createElementVNode("div", _hoisted_99, [
            (_ctx.workType.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_100, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workType, (workType, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "preferred_work ml-6",
                      key: index
                    }, _toDisplayString(workType.replaceAll("_", " ")), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_101, "N/A"))
          ])
        ])
      ])
    ])
  ]))
}